import React, { useState, useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';
import logo from '../assets/logo.png';

/**
 * Navbar component renders the top navigation bar. It displays the company logo
 * and navigation links that scroll to different sections of the page. On
 * smaller screens a hamburger menu opens a sidebar overlay with glassmorphism styling.
 */
const Navbar = ({ onLinkClick }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleLinkClick = () => {
    setIsMobileMenuOpen(false);
    if (onLinkClick) onLinkClick();
  };

  // Prevent body scroll when mobile menu is open
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMobileMenuOpen]);

  return (
    <>
      <header className="navbar" id="navbar">
        <div className="logo">
          <Link to="/" onClick={handleLinkClick}>
            <img src={logo} alt="Aakeeo Technologies logo" width="150" height="50" />
          </Link>
        </div>
        <nav className="desktop-nav">
          <ul>
            <li><NavLink to="/" onClick={handleLinkClick} end>Home</NavLink></li>
            <li><NavLink to="/services" onClick={handleLinkClick}>Services</NavLink></li>
            <li><NavLink to="/blog" onClick={handleLinkClick}>Blog</NavLink></li>
            <li><NavLink to="/case-studies" onClick={handleLinkClick}>Case Studies</NavLink></li>
            <li><NavLink to="/contact" onClick={handleLinkClick}>Contact</NavLink></li>
          </ul>
        </nav>

        {/* Mobile hamburger menu */}
        <button
          className={`mobile-menu-toggle ${isMobileMenuOpen ? 'active' : ''}`}
          onClick={toggleMobileMenu}
          aria-label="Toggle navigation"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </header>

      {/* Mobile sidebar overlay */}
      <div className={`mobile-overlay ${isMobileMenuOpen ? 'active' : ''}`} onClick={handleLinkClick}>
        <nav className="mobile-sidebar" onClick={(e) => e.stopPropagation()}>
          <ul>
            <li><NavLink to="/" onClick={handleLinkClick} end>Home</NavLink></li>
            <li><NavLink to="/services" onClick={handleLinkClick}>Services</NavLink></li>
            <li><NavLink to="/blog" onClick={handleLinkClick}>Blog</NavLink></li>
            <li><NavLink to="/case-studies" onClick={handleLinkClick}>Case Studies</NavLink></li>
            <li><NavLink to="/contact" onClick={handleLinkClick}>Contact</NavLink></li>
          </ul>
        </nav>
      </div>
    </>
  );
};

export default Navbar;